import React from 'react';
import { ModalName } from './config';
import ModalClaimExtra from './ModalClaimExtra';
import ModalClaimDetail from './ModalClaimDetail';
import ErrorModal from './ErrorModal';
const VestingSafeModalContext = /*#__PURE__*/React.createContext({
  openModal: () => {},
  closeModal: () => {}
});

const VestingSafeModalProvider = ({
  children
}) => {
  const [modal, setModal] = React.useState(null);
  const [claimAmount, setClaimAmount] = React.useState(undefined);
  const [feePercentage, setFeePercentage] = React.useState(undefined);
  const [feeAmount, setFeeAmount] = React.useState(undefined);
  const [error, setError] = React.useState(undefined);
  const openModal = React.useCallback((modal, params) => {
    setModal(modal);
    (params === null || params === void 0 ? void 0 : params.claimAmount) && setClaimAmount(params === null || params === void 0 ? void 0 : params.claimAmount);
    (params === null || params === void 0 ? void 0 : params.feePercentage) && setFeePercentage(params === null || params === void 0 ? void 0 : params.feePercentage);
    (params === null || params === void 0 ? void 0 : params.feeAmount) && setFeeAmount(params === null || params === void 0 ? void 0 : params.feeAmount);
    (params === null || params === void 0 ? void 0 : params.error) && setError(params === null || params === void 0 ? void 0 : params.error);
  }, []);
  const closeModal = React.useCallback(() => {
    setModal(null);
  }, []);
  const context = React.useMemo(() => {
    return {
      modal: modal || undefined,
      openModal,
      closeModal
    };
  }, [modal]);

  const renderModal = () => {
    switch (modal) {
      case ModalName.EXTRA_CLAIM:
        return /*#__PURE__*/React.createElement(ModalClaimExtra, {
          feePercentage: feePercentage,
          claimAmount: claimAmount,
          feeAmount: feeAmount,
          onClose: closeModal,
          onSuccess: () => openModal(ModalName.DETAIL),
          onError: error => {
            setError(error);
            openModal(ModalName.ERROR);
          }
        });

      case ModalName.DETAIL:
        return /*#__PURE__*/React.createElement(ModalClaimDetail, {
          onClose: closeModal,
          claimedAmount: claimAmount,
          feeAmount: feeAmount
        });

      case ModalName.ERROR:
        return /*#__PURE__*/React.createElement(ErrorModal, {
          onClose: closeModal,
          error: error
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(VestingSafeModalContext.Provider, {
    value: context
  }, children, renderModal());
};

export const useVestingModal = () => {
  const {
    modal,
    openModal
  } = React.useContext(VestingSafeModalContext);
  return {
    modal,
    openModal
  };
};
export default VestingSafeModalProvider;